import { Button } from "./ui/button";
import { ArrowRight, Sparkles, User } from "lucide-react";
import { motion } from "framer-motion";
import { useAuth } from "../lib/AuthContext";

export function CTA() {
  const { user } = useAuth();
  
  const handlePrimaryAction = () => {
    if (user) {
      window.location.hash = "#/account";
    } else {
      window.location.hash = "#/signup";
    }
  };
  
  const handleSecondaryAction = () => {
    window.location.hash = "#/discover";
  };
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <motion.div 
          className="relative overflow-hidden rounded-3xl gradient-green p-12 md:p-16 text-white"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <motion.div 
              className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full blur-3xl"
              animate={{ 
                x: [0, 50, 0],
                y: [0, 30, 0]
              }}
              transition={{ 
                duration: 8,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
            <motion.div 
              className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"
              animate={{ 
                x: [0, -50, 0],
                y: [0, -30, 0]
              }}
              transition={{ 
                duration: 10,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>

          <motion.div 
            className="relative z-10 text-center max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            {user ? (
              <>
                <h2 className="text-4xl sm:text-5xl mb-6">
                  Continue your
                  <span className="block">cannabis journey</span>
                </h2>
                
                <p className="text-xl opacity-90 mb-10">
                  Explore products, submit reviews, and connect with the community.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button 
                    size="lg" 
                    variant="secondary" 
                    className="gap-2 group bg-white hover:bg-white/90 text-primary"
                    onClick={handlePrimaryAction}
                  >
                    <User className="w-5 h-5" />
                    My Account
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </Button>
                  <Button 
                    size="lg" 
                    variant="ghost" 
                    className="gap-2 border-2 border-white text-white hover:bg-white/10 hover:text-white"
                    onClick={handleSecondaryAction}
                  >
                    <Sparkles className="w-5 h-5" />
                    Browse Products
                  </Button>
                </div>

                <p className="text-sm opacity-75 mt-8">
                  ✓ Free forever plan • ✓ No credit card required • ✓ Cancel anytime
                </p>
              </>
            ) : (
              <>
                <h2 className="text-4xl sm:text-5xl mb-6">
                  Ready to transform your
                  <span className="block">cannabis experience?</span>
                </h2>
                
                <p className="text-xl opacity-90 mb-10">
                  Join all our members who trust CannaBias. Start free, no credit card required.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button 
                    size="lg" 
                    variant="secondary" 
                    className="gap-2 group bg-white hover:bg-white/90 text-primary"
                    onClick={handlePrimaryAction}
                  >
                    Get Started Free
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </Button>
                  <Button 
                    size="lg" 
                    variant="ghost" 
                    className="gap-2 border-2 border-white text-white hover:bg-white/10 hover:text-white"
                    onClick={handleSecondaryAction}
                  >
                    <Sparkles className="w-5 h-5" />
                    Browse Products
                  </Button>
                </div>

                <p className="text-sm opacity-75 mt-8">
                  ✓ Free forever plan • ✓ No credit card required • ✓ Cancel anytime
                </p>
              </>
            )}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}